import React, { useState } from "react";

const BlogsForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    website: "",
    comment: "",
    saveInfo: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(
        "https://accel1.whysocial.in/contact-form.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            website: formData.website,
            message: formData.comment,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSubmitStatus("success");
        // Reset form but keep saveInfo if checked
        setFormData((prev) => ({
          name: prev.saveInfo ? prev.name : "",
          email: prev.saveInfo ? prev.email : "",
          phone: "",
          website: prev.saveInfo ? prev.website : "",
          comment: "",
          saveInfo: prev.saveInfo,
        }));
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="comment-form blog-form">
      <h3>Leave a Comment</h3>

      {submitStatus === "success" && (
        <div className="alert success">
          Thank you! Your comment has been submitted successfully.
        </div>
      )}

      {submitStatus === "error" && (
        <div className="alert error">
          There was an error submitting your comment. Please try again.
        </div>
      )}

      <p>
        Your email address will not be published. Required fields are marked *
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="comment"></label>
          <textarea
            id="comment"
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            required
            placeholder="Comment *"
          />
        </div>

        <div className="form-group">
          <label htmlFor="name"></label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Name *"
            className="style-2"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email"></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="Email *"
            className="style-2"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone"></label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone"
            className="style-2"
          />
        </div>

        <div className="form-group">
          <label htmlFor="website"></label>
          <input
            type="url"
            id="website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            placeholder="Website"
            className="style-2"
          />
        </div>

        <div className="form-checkbox m-tb-1">
          <input
            type="checkbox"
            id="saveInfo"
            name="saveInfo"
            checked={formData.saveInfo}
            onChange={handleChange}
          />{" "}
          <label htmlFor="saveInfo">
            Save my name, email, and website in this browser for the next time I
            comment.
          </label>
        </div>

        <button
          type="submit"
          className="submit-button blog-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit Comment"}
        </button>
      </form>
    </div>
  );
};

export default BlogsForm;
